/**
 * Version check via fetch - detects new deployment and triggers reload.
 * Fetches fresh index.html, compares script src with current, reloads if different.
 */
const LOG_PREFIX = '[Kwizbot VersionCheck]';

function getCurrentScriptSrc() {
	// Support /app/js/app.js, /app/js/app.xxx.js and /assets/xxx.js
	const script = document.querySelector('script[src*="/app/js/app"][src*=".js"], script[src*="/assets/"][src*=".js"]');
	return script ? (script.getAttribute('src') || script.src || '') : '';
}

function getDeployedScriptSrc(html) {
	// Match /app/js/app.js (dev) or /app/js/app.xxx.js (prod with hash) or /assets/xxx.js
	const appMatch = html.match(/src="(\/app\/js\/app(\.[a-f0-9]+)?\.js)"/);
	if (appMatch) return appMatch[1];
	const assetsMatch = html.match(/src="(\/assets\/[^"]+\.js)"/);
	return assetsMatch ? assetsMatch[1] : '';
}

function extractScriptId(src) {
	if (!src) return '';
	const m = src.match(/\/([^/]+\.js)$/);
	return m ? m[1] : src;
}

function getFetchBasePath() {
	const src = getCurrentScriptSrc();
	// /app/js/app.xxx.js -> /app, /assets/xxx.js -> ''
	if (src.includes('/app/js/')) return '/app';
	return '';
}

export function checkForNewVersion() {
	const basePath = getFetchBasePath();
	const url = basePath ? `${window.location.origin}${basePath}/?_v=${Date.now()}` : `${window.location.origin}/?_v=${Date.now()}`;

	console.log(LOG_PREFIX, 'Fetching:', url);
	fetch(url, { cache: 'no-store' })
		.then((r) => r.text())
		.then((html) => {
			const currentSrc = getCurrentScriptSrc();
			const deployedSrc = getDeployedScriptSrc(html);
			const currentId = extractScriptId(currentSrc);
			const deployedId = extractScriptId(deployedSrc);

			console.log(LOG_PREFIX, 'Check result:', {
				current: currentId,
				deployed: deployedId,
				same: currentId === deployedId,
			});

			if (deployedSrc && currentSrc && currentId !== deployedId) {
				console.log(LOG_PREFIX, 'New version detected! Reloading...', {
					from: currentId,
					to: deployedId,
				});
				window.location.href = window.location.pathname + '?nocache=' + Date.now();
			}
		})
		.catch((err) => {
			console.warn(LOG_PREFIX, 'Version check failed:', err?.message || err);
		});
}

export default {
	install(Vue) {
		Vue.prototype.$checkForNewVersion = checkForNewVersion;
	},
};
